<template>
    <component :is="footerComponent" :settings="settings" :social-links="socialLinks">
        <template #logo>
            <img v-if="footerLogo.length > 0" :src="footerLogo[0].url" class="h-full" :class="logoSize">
        </template>

        <template #siteByDigistorm>
            <NuxtLink to="http://www.digistorm.com.au" class="font-medium text-brand-extra-strong hover:underline underline-offset-2 text-sm" target="_blank">
                site by Digistorm
            </NuxtLink>
        </template>

        <template #copyright>
            <span class="font-medium text-brand-extra-strong text-sm">
                © {{currentYear}} {{variables?.siteName}}
            </span>
        </template>
    </component>
</template>

<script setup>
    const { globalSets, digistormSettings, variables, getGlobalSetField } = storeToRefs(useSiteStore())

    const settings = computed(() => {
        const navigationSet = find(globalSets.value, { __typename: 'ds_Navigation_GlobalSet' })

        return {
            footerType: digistormSettings.value.footerType,
            ...Object.entries(navigationSet).reduce((acc, [key, value]) => {
                acc[key] = getGlobalSetField.value('ds_Navigation_GlobalSet', key);
                return acc;
            }, {})
        }
    })

    const socialLinks = computed(() => {
        return getGlobalSetField.value('ds_Socials_GlobalSet', 'socials_SocialLinks')
    })

    const footerComponent = defineAsyncComponent(() =>
        import(`./${settings.value.footerType}/footer.async.vue`)
    )

    const footerLogo = computed(() => {
        return getGlobalSetField.value('ds_Logos_GlobalSet', 'logos_FooterLogo', true)
    })

    const logoSize = computed(() => {
        switch(getGlobalSetField.value('ds_Logos_GlobalSet', 'logos_FooterLogoSize', true)) {
            case 'sm':
                return 'max-h-18 max-w-48'
            case 'lg':
                return 'max-h-54 max-w-144'
            case 'md':
            default:
                return 'max-h-36 max-w-96'
        }
    })

    const currentYear = computed(() => {
        return new Date().getFullYear()
    })
</script>

<style lang="scss" scoped>

</style>
